import type { RouteLocationNormalized } from 'vue-router'
import { defineNuxtRouteMiddleware } from '#app'
import { useLayoutForPath } from '~/domain/shared/authentication/composables/useLayoutPage'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  useLayoutForPath(to.path)
})
